import React, { useEffect, useRef, useState, } from 'react'

import {
    settings, setDateTimeFormatGlobal, getProcessButtons, isUndNullEmpNew, getError, getResponse, getLanguageObj, sendMessageCloseCurrentWindow, LoadingSection, getDtRowIndexNew, 
    setBadgeStatusGenericNew
} from '../../helpers/UtilsHelper';
import useAuth from '../../auth/useAuth';

import AccountEdit from './AccountEdit';
import Menu from '../main/Menu';
import Swal from 'sweetalert2';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { UserService } from '../../services/users/UserService';
import TableIndex from '../main/TableIndex';
import { AccountClass } from '../../classes/account/accountClass';
import { getUserAccountDelete, getUserAccountEnableDisable } from '../../helpers/users/usersHelper';

const $ = window?.$;
const { app, colors, html, icons, images, messages, labels } = settings;
const { urls } = app?.backend;

const currentMethod = 'Users - function';

export default function Users({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const auth = useAuth();
    const dtUsersId = 'dtUsers';
    const dateTimeFormat = {
        date: languageObj?.format?.date?.f1,
        time: languageObj?.format?.time?.type,
    };
    const [account, setAccount] = useState({});
    const [roles, setRoles] = useState([]);
    const [dtRowIndex, setDtRowIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [process, setProcess] = useState({ showLoading: false, edit: false, verfEmail: false, confrEmail: false, authUser: false, wellEmail: false });
    const isMount = useRef(true);
    //#region old code
    // const processButtons = [
    //     { isVisible: true, showDivider: true, isEnabled: true, methodName: 'verfEmail', icon: icons?.fasFa?.envelope, label: labels?.verfEmail?.[languageObj?.id], },
    //     { isVisible: true, showDivider: false, isEnabled: true, methodName: 'confrEmail', icon: icons?.fasFa?.envelopeOpenText, label: labels?.confrEmail?.[languageObj?.id], },
    //     { isVisible: true, showDivider: false, isEnabled: true, methodName: 'authUser', icon: icons?.fasFa?.userTag, label: labels?.authUser?.[languageObj?.id], },
    //     { isVisible: true, showDivider: false, isEnabled: true, methodName: 'wellEmail', icon: icons?.fasFa?.check, label: labels?.wellcomeEmail?.[languageObj?.id], },
    //     { isVisible: true, showDivider: true, isEnabled: true, methodName: backend?.methods?.enableDisableAccount, icon: icons?.fasFa?.toggleOn, label: isUndNullEmp({ data: user?.isDisabled, subMethod: currentMethod, })?.result || !user?.isDisabled ? labels?.disableAccount?.[languageObj?.id] : labels?.enableAccount?.[languageObj?.id], },
    //     { isVisible: true, showDivider: false, isEnabled: true, methodName: backend?.methods?.deleteAccount, icon: isUndNullEmp({ data: user?.isDeleted, subMethod: currentMethod, })?.result || !user?.isDeleted ? icons?.fasFa?.trashAlt : icons?.fasFa?.undo, label: isUndNullEmp({ data: user?.isDeleted, subMethod: currentMethod, })?.result || !user?.isDeleted ? labels?.deleteAccount?.[languageObj?.id] : labels?.restoreAccount?.[languageObj?.id], },
    // ];
    //#endregion old code
    //#endregion variables

    //#region methods
    const setDataDtRow = ({
        user = AccountClass?.getClass(),
        subMethod = '',
        languageObj = GlobalFormats?.getClass(),
    }) => {
        const currentMethod = 'setDataDtRow';
        let response = getResponse({ type: 0 });
        try {
            //#region processButtons
            const processButtons = [
                { isVisible: true, showDivider: true, isEnabled: true, methodName: 'verfEmail', icon: icons?.fasFa?.envelope, label: labels?.verfEmail?.[languageObj?.id], },
                { isVisible: true, showDivider: false, isEnabled: true, methodName: 'confrEmail', icon: icons?.fasFa?.envelopeOpenText, label: labels?.confrEmail?.[languageObj?.id], },
                { isVisible: true, showDivider: false, isEnabled: true, methodName: 'authUser', icon: icons?.fasFa?.userTag, label: labels?.authUser?.[languageObj?.id], },
                { isVisible: true, showDivider: false, isEnabled: true, methodName: 'wellEmail', icon: icons?.fasFa?.check, label: labels?.wellcomeEmail?.[languageObj?.id], },
                { isVisible: true, showDivider: true, isEnabled: true, methodName: 'enableDisableAccount', icon: icons?.fasFa?.toggleOn, label: !user?.isDisabled ? labels?.disableAccount?.[languageObj?.id] : labels?.enableAccount?.[languageObj?.id], },
                { isVisible: true, showDivider: false, isEnabled: true, methodName: 'deleteAccount', icon: !user?.isDeleted ? icons?.fasFa?.trashAlt : icons?.fasFa?.undo, label: !user?.isDeleted ? labels?.deleteAccount?.[languageObj?.id] : labels?.restoreAccount?.[languageObj?.id], },
            ];
            //#endregion processButtons

            response.result = [
                user?.email,
                setDateTimeFormatGlobal({
                    date: user?.created,
                    type: dateTimeFormat?.date,
                    format: dateTimeFormat?.time,
                    addTime: false,
                    withSeconds: false,
                    subMethod: currentMethod
                })?.result,
                setBadgeStatusGenericNew({
                    type: user?.emailVerified ? 0 : 5,
                    value: user?.emailVerified ? `<i class='${icons?.fasFa?.check}'></i>` : `<i class='${icons?.fasFa?.clock}'></i>`,
                    title: user?.emailVerified ? labels?.emailVerified?.[languageObj?.id] : labels?.emailNotVerified?.[languageObj?.id],
                    pointer: true
                }),
                setBadgeStatusGenericNew({
                    type: user?.accountApproved ? 0 : 5,
                    value: user?.accountApproved ? `<i class='${icons?.fasFa?.check}'></i>` : `<i class='${icons?.fasFa?.clock}'></i>`,
                    title: user?.accountApproved ? labels?.accountApproved?.[languageObj?.id] : labels?.accountPendingApproval?.[languageObj?.id],
                    pointer: true
                }),
                setBadgeStatusGenericNew({
                    type: user?.roleId ? 0 : 5,
                    value: user?.roleId ? `<i class='${icons?.fasFa?.check}'></i>` : `<i class='${icons?.fasFa?.clock}'></i>`,
                    title: user?.roleId ? labels?.roleAssigned?.[languageObj?.id] : labels?.roleNotAssigned?.[languageObj?.id],
                    pointer: true
                }),
                setBadgeStatusGenericNew({
                    type: user?.isDisabled ? 1 : 0,
                    value: user?.isDisabled ? `<i class='${icons?.fasFa?.ban}'></i>` : `<i class='${icons?.fasFa?.check}'></i>`,
                    title: user?.isDisabled ? labels?.accountDisabled?.[languageObj?.id] : labels?.accountEnabled?.[languageObj?.id],
                    pointer: true
                }),
                setBadgeStatusGenericNew({
                    type: user?.isDeleted ? -1 : 0,
                    value: user?.isDeleted ? `<i class='${icons?.fasFa?.trashAlt}'></i>` : `<i class='${icons?.fasFa?.check}'></i>`,
                    title: user?.isDeleted ? labels?.accountDeleted?.[languageObj?.id] : labels?.accountNotDeleted?.[languageObj?.id],
                    pointer: true
                }),
                getProcessButtons({
                    id: user?.id,
                    description: user?.email,
                    detailsShow: false,
                    detailsLabel: labels?.detail?.[languageObj?.id],
                    detailsEnabled: false,
                    editShow: true,
                    editLabel: labels?.edit?.[languageObj?.id],
                    editEnabled: true,
                    deleteShow: false,
                    deleteLabel: labels?.delete?.[languageObj?.id],
                    deleteEnabled: false,
                    processButtons: processButtons,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
            ];
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            response.result = [];
        }
        return response;
    }

    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            // Initialize DataTable
            response = setDataTable({ subMethod: currentMethod });
            if (!response?.isSuccess) return;

            // Set Listeners
            response = setQueryCode({ subMethod: currentMethod });
            if (!response?.isSuccess) return;

            // Fetch Data
            const token = auth?.account?.tokenVzLaML?.token;
            response = await UserService.getAll({ token, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            const accounts_ = response?.result || [];
            let dtRows = [];

            if (accounts_?.length > 0) {
                for (const detail of accounts_) {
                    response = setDataDtRow({
                        user: detail,
                        languageObj: languageObj,
                        subMethod: currentMethod
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                    dtRows.push(response?.result);
                }
            }

            $(`#${dtUsersId}`).DataTable().clear().rows.add(dtRows).draw(true);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const setDataTable = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTable';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtUsersId}`).DataTable({
                destroy: true,
                data: [],
                order: [[0, 'asc']],
                columns: [
                    { title: labels?.email?.[languageObj?.id], width: '30%', orderable: true, },
                    { title: labels?.registry?.[languageObj?.id], width: '15%', orderable: true, },
                    { className: 'text-center', title: `${labels?.emailConfi?.[languageObj?.id]}?`, width: '10%', orderable: true, },
                    { className: 'text-center', title: `${labels?.authorized?.[languageObj?.id]}?`, width: '10%', orderable: true, },
                    { className: 'text-center', title: `${labels?.assigRole?.[languageObj?.id]}?`, width: '10%', orderable: true, },
                    { className: 'text-center', title: `${labels?.disabled?.[languageObj?.id]}?`, width: '10%', orderable: true, },
                    { className: 'text-center', title: `${labels?.deleted?.[languageObj?.id]}?`, width: '10%', orderable: true, },
                    { className: 'text-center', title: labels?.process?.[languageObj?.id], width: '5%', orderable: false, },
                ],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis'],
            }).buttons().container().appendTo(`#${dtUsersId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            const tableSelector = `#${dtUsersId} tbody`;

            $(tableSelector).on('click', 'tr', 'td', async function (e) {
                const rowIndex = getDtRowIndexNew({ dtId: dtUsersId, this_: this, subMethod: currentMethod })?.result;
                if (isUndNullEmpNew({ data: rowIndex, subMethod: currentMethod })?.result) return;

                const methodName = e?.target?.attributes?.method?.value || '';
                const id = e?.target?.attributes?.id?.value || '';
                const description = e?.target?.attributes?.description?.value || '';

                if (methodName !== '') {
                    userMethods({
                        id: id,
                        description: description,
                        rowIndex: rowIndex,
                        processType: methodName,
                        subMethod: currentMethod,
                    });
                }
            });
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const userMethods = async ({
        id = '',
        description = '',
        rowIndex = 0,
        processType = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'userMethods';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true, [processType]: true }));
            setDtRowIndex(rowIndex);

            const token = auth?.account?.tokenVzLaML?.token;
            let account_ = {};
            let swalResult = {};

            switch (processType) {
                case 'edit':
                    response = await UserService.getById({ id, token, getRoles: true, subMethod: currentMethod });
                    if (!response?.isSuccess || response?.isWarning) return;

                    setAccount(response?.result?.account || {});
                    setRoles(response?.result?.roles || []);
                    setShowModal(true);
                    break;

                case 'verfEmail':
                case 'confrEmail':
                case 'authUser':
                case 'wellEmail':
                    // Confirmation Dialog
                    const config = {
                        verfEmail: { msg: messages?.doYouWantSendTheConfirmationEmail?.[languageObj?.id], icon: 'warning' },
                        confrEmail: { msg: messages?.doYouWantToChangeTheEmailConfirmationStatus?.[languageObj?.id], icon: 'warning' },
                        authUser: { msg: messages?.doYouWantToChangeTheAuthorizationStatus?.[languageObj?.id], icon: 'warning' },
                        wellEmail: { msg: messages?.doYouWantToSendWelcomeEmail?.[languageObj?.id], icon: 'info' }
                    }[processType];

                    swalResult = await Swal.fire({
                        icon: config.icon,
                        title: labels?.warning?.[languageObj?.id],
                        html: `${config.msg}<br/>${labels?.user?.[languageObj?.id]}: <b>${description}</b>`,
                        confirmButtonColor: colors?.warningColorExp,
                        confirmButtonText: labels?.yes?.[languageObj?.id],
                        showCancelButton: true,
                        cancelButtonColor: colors?.successColorExp,
                        cancelButtonText: labels?.no?.[languageObj?.id],
                        customClass: {
                            popup: html?.popup,
                            confirmButton: html?.buttons?.primary,
                            cancelButton: html?.buttons?.secondary,
                        },
                    });

                    if (!swalResult.isConfirmed) return;

                    // Execute Service
                    if (processType === 'verfEmail') {
                        response = await UserService.sendEmailVerification({ id, token, subMethod: currentMethod });
                    } else if (processType === 'confrEmail') {
                        response = await UserService.emailVerificationSet({ id, token, subMethod: currentMethod });
                    } else if (processType === 'authUser') {
                        response = await UserService.authorized({ id, userId: auth?.account?.uid, token, subMethod: currentMethod });
                    } else if (processType === 'wellEmail') {
                        response = await UserService.welcomeEmailSend({ id, token, subMethod: currentMethod });
                    }

                    if (!response?.isSuccess || response?.isWarning) return;
                    account_ = response?.result || {};

                    response = setDataDtRow({
                        user: account_,
                        languageObj: languageObj,
                        subMethod: currentMethod
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                    // const accountDt_ = [response?.result];
                    const accountDt_ = response?.result || [];

                    $(`#${dtUsersId}`).DataTable().row(rowIndex).data(accountDt_).draw(true);

                    response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
                    break;

                case 'enableDisableAccount':
                    response = await getUserAccountEnableDisable({
                        id: id,
                        rowIndex: rowIndex,
                        dtId: dtUsersId,
                        $: $,
                        auth: auth,
                        languageObj: languageObj,
                        setDataDtRow: setDataDtRow,
                        subMethod: currentMethod
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                    break
                case 'deleteAccount':
                    response = await getUserAccountDelete({
                        id: id,
                        rowIndex: rowIndex,
                        dtId: dtUsersId,
                        $: $,
                        auth: auth,
                        languageObj: languageObj,
                        setDataDtRow: setDataDtRow,
                        subMethod: currentMethod
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                    break
                default:
                    break;
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, [processType]: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'form - onLoad',
        });
        return () => {
            isMount.current = false;
        }
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName={'settings'} process={'users'} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Premium Bar) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.users?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.users?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='card border-0 shadow-lg login-card' >
                            <LoadingSection alt='loadingSection'
                                className='overlay dark text-white'
                                height={20}
                                hidden={!process?.showLoading}
                                width={20}
                                languageId={languageObj?.id}
                                subMethod={currentMethod} />

                            <div className='card-header bg-white border-0 pt-4 px-4'>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <div className='d-flex align-items-center'>
                                        <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                            style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <img alt='imgRoles'
                                                style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                src={images?.icons?.group} />
                                        </div>
                                        <div className='d-flex flex-column'>
                                            <h5 className='mb-0 font-weight-bold text-dark'>{labels?.users?.[languageObj?.id]}</h5>
                                            <div className='mt-1'>
                                                <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                    <i className={`${icons?.fasFa?.list} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='card-body px-4 pb-4'>
                                <TableIndex tableId={dtUsersId} languageObj={languageObj} />
                            </div>

                        </div>

                    </div>
                </section>

                {showModal && (
                    <AccountEdit modalObj={{
                        $: $,
                        account: account,
                        setAccount: setAccount,
                        auth: auth,
                        roles: roles,
                        setRoles: setRoles,
                        showModal: showModal,
                        setShowModal: setShowModal,
                        dtId: dtUsersId,
                        dtRowIndex: dtRowIndex,
                        setDtRowIndex: setDtRowIndex,
                        // processButtons: processButtons,
                        setDataDtRow: setDataDtRow,
                        dateTimeFormat: dateTimeFormat,
                    }} />
                )}
            </div>

        </div>
    )
}